import { render, staticRenderFns } from "./VTabNav.vue?vue&type=template&id=fe71b216&scoped=true&"
import script from "./VTabNav.vue?vue&type=script&lang=js&"
export * from "./VTabNav.vue?vue&type=script&lang=js&"
import style0 from "./VTabNav.vue?vue&type=style&index=0&id=fe71b216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe71b216",
  null
  
)

export default component.exports